export default {
  SET_SHOW_CREATE_EDIT_VIEW(state, payload) {
    state.showCreateEditView = payload
  },
  SET_SHOW_CREATE_BACK_ARROW(state, payload) {
    state.showCreateEditBackArrow = payload
  },
}
